import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { AccountWithOwnership } from '../hooks/marketplaces/allegro/accounts'

interface State {
  current?: AccountWithOwnership
  setCurrent: (acc: AccountWithOwnership | undefined) => void
  autoSelectFirst: (accounts: AccountWithOwnership[], isLoading: boolean) => void
}

export const useAccountStore = create<State>()(
  persist(
    (set, get) => ({
      current: undefined,
      setCurrent: (acc: AccountWithOwnership | undefined) => set({ current: acc }),
      autoSelectFirst: (accounts: AccountWithOwnership[], isLoading: boolean) => {
        // Skip while the fetch is still in flight to avoid transient clearing.
        if (isLoading) return

        const { current } = get()

        if (accounts.length === 0) {
          // Fetch is done and user genuinely has no accounts — clear stale selection.
          if (current) set({ current: undefined })
          return
        }

        if (!current) {
          set({ current: accounts[0] })
          return
        }

        const fresh = accounts.find((acc) => acc.id === current.id)
        if (!fresh) {
          set({ current: accounts[0] })
          return
        }

        // Rehydrate persisted selection from the latest API payload so fields like
        // marketplace_specific_data (base_marketplace) aren't stuck from localStorage.
        if (fresh !== current) {
          set({ current: fresh })
        }
      }
    }),
    {
      name: 'account-storage',
      partialize: (state) => ({ current: state.current })
    }
  )
) 